module.exports = __webpack_public_path__ + "static/assets/7ea6e2a1efda9446b3eba87c42deec04.svg";